import React from 'react'
import {CustomTableRow} from './table-row.js'
import moment from 'moment'

const HighLowTable = (props) => {
  const account = props.account

  return (
    <>
      <h2>High/Low Days</h2>
      {account.user.high_low_macros ?
        <div className='timeline-container'>
          <div className="highlow-table">
            <div className='custom-table-header-scroll' id='highlow-table-header'>
              <p className='date'>Date</p>
              <p className='target'>Protein</p>
              <p className='target'>Carbs</p>
              <p className='target'>Fat</p>
              <p className='target'>Calories</p>
            </div>
            {account.user.high_low_macros.map((record, index) => {
              const date = (moment.utc(record.date).format('MMM D, YYYY'));
              return (
                <CustomTableRow
                  key={index}
                  date={date}
                  // status={rowData[i].type}
                  protein={(record.protein) ? Math.round(record.protein) : '-' }
                  carbs={(record.carbs) ? Math.round(record.carbs) : '-' }
                  fat={(record.fat) ? Math.round(record.fat) : '-' }
                  calories={(record.calories) ? Math.round(record.calories) : '-' }
                />
              )
              // <TableRow style={{height: 25}} key={index}>
              //   <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{record.date.split('T')[0]}</TableCell>
              //   <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.calories) ? Math.round(record.calories) : '-' }</TableCell>
              //   <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.protein) ? Math.round(record.protein) : '-' }</TableCell>
              //   <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.carbs) ? Math.round(record.carbs) : '-' }</TableCell>
              //   <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.fat) ? Math.round(record.fat) : '-' }</TableCell>
              // </TableRow>
            })}
          </div>
        </div>
      :
        <div className="avn-widget">
          <p style={{ color: '#ff649f', fontSize: '1.25rem', fontStyle: 'bold', textAlign: 'center', padding: '20px 0px'}}>User has no high-low days.</p>
        </div>
      }
      {/* <div className='avn-widget'>
        <StyledTable>
          <>
            {account.user.high_low_macros ?
              <Table>
                <TableHead>
                  <TableRow style={{height: 25}}>
                    <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>Date</TableCell>
                    <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>Calories</TableCell>
                    <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>Protein</TableCell>
                    <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>Carbs</TableCell>
                    <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>Fat</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {account.user.high_low_macros.map((record, index) =>
                    <TableRow style={{height: 25}} key={index}>
                      <TableCell style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{record.date.split('T')[0]}</TableCell>
                      <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.calories) ? Math.round(record.calories) : '-' }</TableCell>
                      <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.protein) ? Math.round(record.protein) : '-' }</TableCell>
                      <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.carbs) ? Math.round(record.carbs) : '-' }</TableCell>
                      <TableCell numeric style={{color: '#FFF', textAlign: 'center', padding: 0 }}>{(record.fat) ? Math.round(record.fat) : '-' }</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            :
              <p style={{textAlign: 'center'}}>User has no high-low days.</p>
            }
          </>
        </StyledTable>
      </div> */}
    </>
  )
}

export default HighLowTable
